export const createFilterConfig = () => {
  return [
    {
      name: "name",
      fieldType: "text",
      placeholder: "Name",
      filterType: 'search'
    },
    {
      name: "provider",
      fieldType: "text",
      placeholder: "Provider",
      filterType: 'search'
    },
  ];
};
